/**
 * Normalises customisation image/icon field values to a usable URL string.
 * Fields may be stored as a plain string or as an object with `url`.
 */
export const getImageFieldUrl = (value: unknown): string => {
  if (value == null) {
    return '';
  }
  if (typeof value === 'string') {
    return value.trim();
  }
  if (typeof value === 'object' && 'url' in value && typeof (value as { url: unknown }).url === 'string') {
    return String((value as { url: string }).url).trim();
  }
  return '';
};
